module.exports = __webpack_public_path__ + "img/icon2.9a101981.png";